import { useContext } from 'react'
import GlobalContext from '../global'
import Link from './elements/link'
import './Navigation.scss'

export default function Navigation() {
  const global = useContext(GlobalContext)
  return (
    <div className="navigation">
      {global.data.body.map((navitem, i) => {
        return (
          <Link key={`nav-item-${i}`} type="internal" route={`/${navitem.primary.link.uid}`}>
            <a className="link">
              <div className="icon">
                <div className="red" style={{ backgroundImage: `url(${navitem.primary.icon_red.url})` }} />
                <div className="white" style={{ backgroundImage: `url(${navitem.primary.icon_white.url})` }} />
              </div>
              <div className="title">{navitem.primary.label}</div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                <polyline points="10,10 30,30 10,50" />
              </svg>
            </a>
          </Link>
        )
      })}
    </div>
  )
}
